import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

const description: CSSProperties = {
  fontFamily: fontFamilySans,
  color: greys.slate,
  fontSize: 14,
  lineHeight: "24px",
  marginBottom: 15,
};

const slackForm: CSSProperties = {
  marginTop: 30,
};

const slackSettings: CSSProperties = {
  border: `1px solid ${greys.borderGrey}`,
  padding: "15px 25px",
};

export const styles = {
  description,
  slackForm,
  slackSettings,
};
